export const CustomerServiceManagementMarkBrand = () => {
	return (
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_793_43052)">
				<path
					d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
					fill="#FFC716"
				/>
				<g clipPath="url(#clip1_793_43052)">
					<path
						d="M34.4932 35.6143C31.9074 37.7304 28.602 39 25 39C21.3982 39 18.0928 37.7305 15.507 35.6145L21.2254 29.8961C22.3145 30.5948 23.61 31 25 31C26.3902 31 27.6857 30.5948 28.7749 29.896L34.4932 35.6143Z"
						fill="#101214"
					/>
					<path
						d="M36.6145 33.493C38.7305 30.9072 40 27.6018 40 24C40 20.3982 38.7305 17.0928 36.6145 14.507L30.8961 20.2254C31.5948 21.3145 32 22.61 32 24C32 25.39 31.5948 26.6855 30.8961 27.7746L36.6145 33.493Z"
						fill="#101214"
					/>
					<path
						d="M34.4932 12.3857L28.7749 18.104C27.6857 17.4052 26.3902 17 25 17C23.61 17 22.3145 17.4052 21.2254 18.1039L15.507 12.3855C18.0928 10.2695 21.3982 9 25 9C28.602 9 31.9074 10.2696 34.4932 12.3857Z"
						fill="#101214"
					/>
					<path
						d="M13.3857 14.5068C11.2696 17.0926 10 20.398 10 24C10 27.602 11.2696 30.9074 13.3857 33.4932L19.104 27.7749C18.4052 26.6857 18 25.3902 18 24C18 22.6098 18.4052 21.3143 19.104 20.2251L13.3857 14.5068Z"
						fill="#101214"
					/>
				</g>
				<path d="M11.7588 38.957H24.2588L21.2588 29.957L11.7588 38.957Z" fill="#101214" />
			</g>
			<defs>
				<clipPath id="clip0_793_43052">
					<path
						d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
						fill="white"
					/>
				</clipPath>
				<clipPath id="clip1_793_43052">
					<rect width="48" height="48" fill="white" transform="translate(1)" />
				</clipPath>
			</defs>
		</svg>
	);
};
